import axios from 'axios';
import getVideoId from 'get-video-id';

export default {
  methods: {
    getVideoInformation(param) {
      return getVideoId(param);
    },

    async getVideoThumbnail(param) {
      const information = this.getVideoInformation(param || '');
      let thumbnail = '';

      if (information && information.service === 'youtube') {
        thumbnail = `http://img.youtube.com/vi/${information.id}/hqdefault.jpg`;
      } else if (information && information.service === 'vimeo') {
        await axios.get(`https://vimeo.com/api/v2/video/${information.id}.json`)
          .then((response) => {
            thumbnail = response.data[0].thumbnail_large;
          })
          .catch((error) => {
            console.log('Vimeo error', error);
          });
      }
      return thumbnail;
    },
  },
};
